import api from "./api";
const svc = {
  boletosDisponiveis: (p)       => { const qs = new URLSearchParams(p); return api("GET", `/renegociacoes/boletos-disponiveis?${qs}`); },
  simular:            (data)    => api("POST", "/renegociacoes/simular", data),
  confirmar:          (data)    => api("POST", "/renegociacoes/confirmar", data),
  listar:             (p = {})  => { const qs = new URLSearchParams(Object.entries(p).filter(([, v]) => v !== "" && v !== undefined)); return api("GET", `/renegociacoes?${qs}`); },
  stats:              (p = {})  => { const qs = new URLSearchParams(Object.entries(p).filter(([, v]) => v !== "" && v !== undefined)); return api("GET", `/renegociacoes/stats?${qs}`); },
  buscarPorId:        (id)      => api("GET", `/renegociacoes/${id}`),
  imprimirAcordo:     (id)      => api("GET", `/renegociacoes/${id}/imprimir`),
  cancelar:           (id, data)=> api("PATCH", `/renegociacoes/${id}/cancelar`, data),
  atualizarVencidas:  ()        => api("PATCH", "/renegociacoes/atualizar-vencidas", {}),
};
export default svc;
